// extracted by mini-css-extract-plugin
module.exports = {"Languages":"Languages_Languages__bG39Y","anim":"Languages_anim__3rSd4"};